(function (kok) {
  const SINIRSIZ = 999999;

  function setAdedi(dist) {
    return dist.reduce((toplam, h) => toplam + h.q, 0);
  }

  function stokDegeri(deger) {
    if (deger === null || deger === undefined) return SINIRSIZ;
    const sayi = Number(deger);
    if (!isFinite(sayi)) return 0;
    return Math.max(0, Math.floor(sayi));
  }

  function stokToplami(dist, stok) {
    return dist.reduce((toplam, h) => toplam + stokDegeri(stok[h.k] === undefined ? 0 : stok[h.k]), 0);
  }

  function sinirsizMi(dist, stok) {
    return dist.some((h) => stokDegeri(stok[h.k] === undefined ? 0 : stok[h.k]) >= SINIRSIZ);
  }

  function enFazlaSet(dist, stok, esik) {
    const adet = setAdedi(dist);
    if (adet < 1) return 0;
    if (sinirsizMi(dist, stok)) return SINIRSIZ;
    const toplam = stokToplami(dist, stok);
    if (toplam < (esik || 0)) return 0;
    return Math.floor(toplam / adet);
  }

  function sonrakiSet(dist, kalan) {
    const al = {};
    let eksik = 0;
    for (const h of dist) {
      const mevcut = Math.max(0, kalan[h.k] || 0);
      const alinan = Math.min(h.q, mevcut);
      al[h.k] = alinan;
      eksik += h.q - alinan;
    }
    while (eksik > 0) {
      let secilen = null;
      let secilenBos = 0;
      for (const h of dist) {
        const bos = Math.max(0, kalan[h.k] || 0) - al[h.k];
        if (bos <= 0) continue;
        if (secilen === null || bos * secilen.q > secilenBos * h.q) {
          secilen = h;
          secilenBos = bos;
        }
      }
      if (secilen === null) return null;
      al[secilen.k] += 1;
      eksik -= 1;
    }
    return al;
  }

  function kuyruk(dist, stok, adet) {
    const kalan = {};
    for (const h of dist) kalan[h.k] = stokDegeri(stok[h.k] === undefined ? 0 : stok[h.k]);
    const setler = [];
    for (let n = 0; n < adet; n++) {
      const set = sonrakiSet(dist, kalan);
      if (!set) break;
      for (const h of dist) kalan[h.k] -= set[h.k];
      setler.push(set);
    }
    return setler;
  }

  function toplam(dist, stok, adet) {
    const sonuc = {};
    for (const h of dist) sonuc[h.k] = 0;
    if (adet < 1) return sonuc;
    const setler = kuyruk(dist, stok, adet);
    if (setler.length !== adet) return null;
    for (const set of setler) for (const h of dist) sonuc[h.k] += set[h.k];
    return sonuc;
  }

  function ayni(dist, a, b) {
    if (!a || !b) return false;
    return dist.every((h) => (a[h.k] || 0) === (b[h.k] || 0));
  }

  function sepetDurumu(dist, hucreler, esik) {
    const stok = {};
    const adet = {};
    let parca = 0;
    for (const h of dist) {
      stok[h.k] = 0;
      adet[h.k] = 0;
    }
    for (const h of hucreler || []) {
      if (!(h.k in stok)) continue;
      stok[h.k] = h.id ? stokDegeri(h.stok) : 0;
      adet[h.k] = Math.max(0, Math.floor(Number(h.adet) || 0));
      parca += adet[h.k];
    }
    const birim = setAdedi(dist);
    const enFazla = enFazlaSet(dist, stok, esik);
    const oran = birim > 0 ? parca / birim : 0;
    let gecerli = Number.isInteger(oran) && oran >= 1 && oran <= enFazla;
    if (gecerli) gecerli = ayni(dist, toplam(dist, stok, oran), adet);
    let onerilen = 0;
    if (enFazla >= 1 && birim > 0) onerilen = Math.min(Math.max(Math.round(oran), 1), enFazla);
    return { gecerli, set: Math.floor(oran), parca, birim, enFazla, onerilen, stok, adet };
  }

  const api = { SINIRSIZ, setAdedi, stokDegeri, stokToplami, enFazlaSet, sonrakiSet, kuyruk, toplam, ayni, sepetDurumu };
  kok.SetDagitim = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
